/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeUserSessionSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RevokeUserSessionSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RevokeUserSessionSecurity = {
  option1?: RevokeUserSessionSecurityOption1 | undefined;
  option2?: RevokeUserSessionSecurityOption2 | undefined;
};

export type RevokeUserSessionRequest = {
  /**
   * The user_session id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type RevokeUserSessionSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RevokeUserSessionSecurityOption1$outboundSchema: z.ZodMiniType<
  RevokeUserSessionSecurityOption1$Outbound,
  RevokeUserSessionSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function revokeUserSessionSecurityOption1ToJSON(
  revokeUserSessionSecurityOption1: RevokeUserSessionSecurityOption1,
): string {
  return JSON.stringify(
    RevokeUserSessionSecurityOption1$outboundSchema.parse(
      revokeUserSessionSecurityOption1,
    ),
  );
}

/** @internal */
export type RevokeUserSessionSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RevokeUserSessionSecurityOption2$outboundSchema: z.ZodMiniType<
  RevokeUserSessionSecurityOption2$Outbound,
  RevokeUserSessionSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function revokeUserSessionSecurityOption2ToJSON(
  revokeUserSessionSecurityOption2: RevokeUserSessionSecurityOption2,
): string {
  return JSON.stringify(
    RevokeUserSessionSecurityOption2$outboundSchema.parse(
      revokeUserSessionSecurityOption2,
    ),
  );
}

/** @internal */
export type RevokeUserSessionSecurity$Outbound = {
  Option1?: RevokeUserSessionSecurityOption1$Outbound | undefined;
  Option2?: RevokeUserSessionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RevokeUserSessionSecurity$outboundSchema: z.ZodMiniType<
  RevokeUserSessionSecurity$Outbound,
  RevokeUserSessionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RevokeUserSessionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RevokeUserSessionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function revokeUserSessionSecurityToJSON(
  revokeUserSessionSecurity: RevokeUserSessionSecurity,
): string {
  return JSON.stringify(
    RevokeUserSessionSecurity$outboundSchema.parse(revokeUserSessionSecurity),
  );
}

/** @internal */
export type RevokeUserSessionRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const RevokeUserSessionRequest$outboundSchema: z.ZodMiniType<
  RevokeUserSessionRequest$Outbound,
  RevokeUserSessionRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function revokeUserSessionRequestToJSON(
  revokeUserSessionRequest: RevokeUserSessionRequest,
): string {
  return JSON.stringify(
    RevokeUserSessionRequest$outboundSchema.parse(revokeUserSessionRequest),
  );
}
